import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ProdConfig } from './blocks/config/prod.config';
import { NewssoappAppModule } from './app.module';

ProdConfig();

platformBrowserDynamic()
    .bootstrapModule(NewssoappAppModule, { preserveWhitespaces: true })
    .then(success => {})
    .catch(err => {});
